import { COVERABLE_CODE } from '../../../constants/coverable';
import { type ProductName_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { type CoverablePriceKey } from '../types';

const getEditCoverableKey = (coverableCode: ProductName_Top): CoverablePriceKey => {
    switch (coverableCode) {
        case COVERABLE_CODE.dog:
            return 'dog';
        case COVERABLE_CODE.cat:
            return 'cat';
        case COVERABLE_CODE.privateContent:
            return 'content';
        case COVERABLE_CODE.car:
            return 'car';
        case COVERABLE_CODE.travelHousehold:
        case COVERABLE_CODE.travelIndividual:
            return 'travel';
        case COVERABLE_CODE.accident:
            return 'adultAccident';
        case COVERABLE_CODE.cho:
            return 'cho';
        case COVERABLE_CODE.prhHouse:
            return 'prhHouse';
        case COVERABLE_CODE.prhHolidayHome:
            return 'prhHolidayHome';
        default:
            throw new Error(`Unsupport for coverable with code: ${String(coverableCode)}`);
    }
};

const isPrivateHouse = (productName: ProductName_Top): boolean => {
    return productName === 'top_prh_house' || productName === 'top_prh_holiday_home';
};

export { getEditCoverableKey, isPrivateHouse };
